import { useTranslation } from "react-i18next";
import { Textarea } from "@/components/ui/textarea";

export const CommentsSection = ({ form }) => {
  const { t } = useTranslation();

  const {
    isViewMode,
    internalComment,
    setInternalComment,
    externalComment,
    setExternalComment,
    invoice,
  } = form;

  // View mode
  if (isViewMode) {
    return (
      <div className='w-full'>
        <div className='w-full flex justify-between flex-wrap'>
          <div className='w-full md:w-[49%] m-auto md:m-0'>
            <div className='text-xl font-medium pt-14 pb-6'>
              {t("invoices:internal_comment")}
            </div>
            <Textarea
              readOnly={true}
              disabled
              placeholder={t("invoices:internal_comment")}
              value={invoice?.internalComment ?? ''}
              className="h-20 bg-white"
            />
          </div>
          <div className='w-full md:w-[49%] m-auto md:m-0'>
            <div className='text-xl font-medium pt-14 pb-6'>
              {t("invoices:comment_on_invoice")}
            </div>
            <Textarea
              readOnly={true}
              disabled
              placeholder={t("invoices:comment_on_invoice")}
              value={invoice?.externalComment ?? ''}
              className="h-20 bg-white"
            />
          </div>
        </div>
      </div>
    );
  }

  // Create/Edit mode
  return (
    <div className='w-full flex justify-between flex-wrap'>
      <div className='w-full md:w-[49%] m-auto md:m-0'>
        <div className='text-xl font-medium pt-14 pb-6'>
          {t("invoices:internal_comment")}
        </div>
        <Textarea
          placeholder={t("invoices:internal_comment")}
          value={internalComment ?? ''}
          onChange={(e) => setInternalComment(e.target.value)}
          className="h-20 bg-white"
        />
      </div>
      <div className='w-full md:w-[49%] m-auto md:m-0'>
        <div className='text-xl font-medium pt-14 pb-6'>
          {t("invoices:comment_on_invoice")}
        </div>
        <Textarea
          placeholder={t("invoices:comment_on_invoice")}
          value={externalComment ?? ''}
          onChange={(e) => setExternalComment(e.target.value)}
          className="h-20 bg-white"
        />
      </div>
    </div>
  );
};
